/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Storage } from 'aws-amplify';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import last from 'lodash/last';
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";


const useStyles = makeStyles((theme) => ({
  root: {
    'marginTop': 8,
    '& img': {
      width: 100,
      height: 80,
      objectFit: 'cover',
    },
    wordBreak: 'break-word'
  },
  paper: {
    backgroundColor: 'rgba(0,0,0,.7)',
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  close: {
    position: 'absolute',
    top: 0,
    right: 5,
    color: 'white'
  },
  object: {
    width: '100%',
    height: '100vh'
  }
}));

const PDFViewer = ({ onClose, url }) => {
  const classes = useStyles();

  return (
    <Dialog
      onBackdropClick={onClose}
      onClose={onClose}
      open
      fullScreen
      classes={{
        paper: classes.paper
      }}
    >
      <DialogContent
        classes={
          {
            root: classes.content,
          }
        }
      >
        <object className={classes.object} data={url} />
        <IconButton variant="" color="default" onClick={onClose} className={classes.close}>
          <CloseIcon />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};



const Screenshot = ({ onClose, url }) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      open
      fullScreen
      classes={{
        paper: classes.paper
      }}
    >
      <DialogContent
        classes={
          {
            root: classes.content,
          }
        }
      >
        <img src={url} alt="result-screenshot" />
        <IconButton variant="" color="default" onClick={onClose} className={classes.close}>
          <CloseIcon />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};



const Documents = ({ onClose, url }) => {
  const classes = useStyles();
  const docs = [
    { uri: url },
  ];

  return (
    <Dialog

      onClose={onClose}
      open
      fullScreen
      classes={{
        paper: classes.paper
      }}
    >

      <DialogContent
        classes={
          {
            root: classes.content,
          }
        }
      >
        <DocViewer style={{ width: 1100, height: 600 }} pluginRenderers={DocViewerRenderers} documents={docs} />
        <IconButton variant="" color="default" onClick={onClose} className={classes.close}>
          <CloseIcon />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};

const MessageAttachment = ({ fileKey, url: fileUrl }) => {
  const classes = useStyles();
  const [url, setUrl] = useState(fileUrl);
  const [showImg, setImg] = useState(false);
  const [showPdf, setPdf] = useState(false);
  let [showDoc, setDoc] = useState(false);
  const isImg = (fileKey || fileUrl).match(/.png|.jpg|.jpeg|gif$/);
  const isPdf = (fileKey || fileUrl).match(/.pdf$/);
  // const isPdf = (fileKey || fileUrl).match(/.xls |.xlsx |.csv$/);

  const fileName = fileKey ? fileKey.substr(37) : last(fileUrl.split('/'));

  useEffect(() => {
    if (fileKey) {
      Storage.get(fileKey, { download: false }).then((resp) => setUrl(resp));
    }
  }, []);

  return (
    <>
      <a
        className={classes.root}
        href={'#'}
        target={null}
        onClick={(e) => e.stopPropagation()}
      >


        {isImg ?
          <img
            src={url}
            onClick={(e) => {
              e.stopPropagation();
              setImg(true);
              // console.log(url)
            }}
          />

          : isPdf ?
            // (fileName.indexOf('.Pdf') !== -1) ?
            (<>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setPdf(true)

                }}
              >
                {fileName}
              </span>

              <IconButton
                size="small"
                style={{ marginRight: 'auto' }}
                onClick={(e) => {
                  setPdf(true)

                }}
              >
                <OpenInNewIcon fontSize="small" color="action" />
              </IconButton>
            </>)
            :

            (<>
              <span
                onClick={(e) => {
                  console.log(url.slice(0, url.lastIndexOf('.') + (url.slice(url.lastIndexOf('.'), url.indexOf('?'))).length))
                  e.stopPropagation();
                  setDoc(true)


                }}
              >
                {fileName}
              </span>

              <IconButton
                size="small"
                style={{ marginRight: 'auto' }}
                onClick={(e) => {
                  setDoc(true)
                }}
              >
                <OpenInNewIcon fontSize="small" color="action" />
              </IconButton>
            </>)

        }


      </a>
      {
        showImg && (
          <Screenshot
            url={url}
            onClose={(e) => {
              e.stopPropagation();
              setImg(false);
            }}
          />
        )}
      {
        showPdf && (
          <PDFViewer
            url={url}
            onClose={(e) => {
              e.stopPropagation();
              setPdf(false)
            }}
          />
        )}

      {/* {showDoc && <AllDocViewer url={url.slice(0, url.lastIndexOf('.') + 5)} />} */}
      {showDoc && (
        <Documents
          pluginRenderers={DocViewerRenderers}
          url={url.slice(0, url.lastIndexOf('.') + (url.slice(url.lastIndexOf('.'), url.indexOf('?'))).length)}
          onClose={(e) => {
            e.stopPropagation();
            setDoc(false);
          }}
        />
      )}
    </>
  );
};

export default MessageAttachment;
